import JsBarcode from 'jsbarcode';
import { DOMImplementation, XMLSerializer } from 'xmldom';

// DOC
// https://pdfmake.github.io/docs/0.1/document-definition-object/qr/

export class ImpressaoEtiqueta {

  constructor(dadosParaImpressao) {
    this.dadosParaImpressao = dadosParaImpressao;
  }

  async PreparaDocumento() {
    const corpoDocumento = this.CriaCorpoDocumento(this.dadosParaImpressao);
    const documento = this.GerarDocumento(corpoDocumento);
    return documento;
  }

  CriaCorpoDocumento() {
    const tightLayout = {
      defaultBorder: false,
      paddingLeft: () => 0,
      paddingRight: () => 0,
      paddingTop: () => 0,
      paddingBottom: () => 0,
    };

    const labels = this.dadosParaImpressao.moldsWagon.map(({ mold, piece }) => {
      const getMold = this.dadosParaImpressao.wagon.isagA_Vagoes_Fornos_Pecas
        .some(w => w.ordem_Serial === piece.ordem_Serial && !w.ativo)

      if (getMold)
        return null
      if (mold.molde_SAPLocal === "NÃO CADASTRADO")
        return null

      const xmlSerializer = new XMLSerializer();
      const document = new DOMImplementation().createDocument('http://www.w3.org/1999/xhtml', 'html', null);
      const svgNode = document.createElementNS('http://www.w3.org/2000/svg', 'svg');

      const code = mold.molde_SAPLocal !== "NÃO CADASTRADO"
        ? `${this.dadosParaImpressao.wagon.vagao_Key}.${mold.molde_Key}.${piece.ordem_Serial}`
        : "00000000"

      JsBarcode(svgNode, code, {
        xmlDocument: document,
        width: .55,
        height: 12,
        fontSize: 0,
        displayValue: false,
      });

      const svgText = xmlSerializer.serializeToString(svgNode);

      return [
        {
          layout: tightLayout,
          table: {
            widths: ['*', 'auto'],
            body: [[
              { text: mold.molde_Lote, fontSize: 8, bold: true },
              { text: mold.molde_SAPLocal, fontSize: 8, bold: true, alignment: 'right' },
            ]],
          },
        },
        { text: mold.molde_Codigo, fontSize: 6, lineHeight: 1 },
        { text: mold.molde_Descricao, fontSize: 6, lineHeight: 1 },
        {
          layout: tightLayout,
          table: {
            widths: ['*', '*', '*'],
            body: [
              [
                { text: 'Vagão', bold: true, fontSize: 5 },
                { text: 'Forno', bold: true, fontSize: 5 },
                { text: 'Ordem', bold: true, fontSize: 5 },
              ],
              [
                { text: this.dadosParaImpressao.wagon.vagao_Serial, fontSize: 5 },
                { text: this.dadosParaImpressao.typesPiecesCombinations.forno, fontSize: 5 },
                { text: piece.ordem_Serial, fontSize: 5 },
              ],
            ],
          },
        },
        {
          svg: svgText,
          alignment: 'center',
          margin: [0, 1, 0, 0],
        },
      ];
    }).filter(Boolean);

    // adiciona quebra de página entre etiquetas (uma etiqueta por página)
    const flat = [];
    labels.forEach((label, idx) => {
      flat.push(...label);
      if (idx < labels.length - 1) {
        flat.push({ text: '', pageBreak: 'after' });
      }
    });
    return flat;
  }

  GerarDocumento(content) {
    // 100mm x 30mm em pontos (1mm = 2.83465pt)
    const documento = {
      pageSize: { width: 283.46, height: 85.04 },
      pageMargins: [4, 2, 4, 2],
      content: content,
      defaultStyle: {
        lineHeight: 1,
      },
    };

    return documento;
  }
}
